
interface Form {
  name: string;
  collocation: number;
  subcollocation: number;
  price_min: string;
  price_max: string;
  status: string;
}
import { Component, Vue } from 'vue-property-decorator';
import { STATUS_LIST } from '@/constants';
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/suit`,
  collocation: `${FCAPI}/boss/ruan/collocation`,
  online: `${FCAPI}/boss/ruan/suit/onlinestatus`,
  sort: `${FCAPI}/boss/ruan/suit/sort`,
};
@Component
export default class RuanPackageList extends Vue {
  is_loading = false;
  form: Form = {
    name: '',
    collocation: 0,
    subcollocation: 0,
    price_min: '',
    price_max: '',
    status: '0',
  };
  collocation_list = [];
  collocation_list_obj: any = {};
  subcollocation_list = [];
  subcollocation_list_obj: any = {};
  status_list = STATUS_LIST;
  table_data = {};
  page = 1;

  handChangePaging(pagination: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  async onChangeSort(item: any) {
    const res = await this.$axios.put(`${API.sort}/${item.id}`, {
      id: item.id,
      sort: item.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('修改成功');
    await this.query(this.page);
  }

  async onChangeOnlineStatus(item: any) {
    const res = await this.$axios.put(`${API.online}/${item.id}`, {
      id: item.id,
      online_status: item.online_status === 1 ? 5 : 1,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.query(this.page);
  }

  onSelectCollocation(value: any) {
    this.form.subcollocation = 0;
    const subcollocation = this.collocation_list.filter((item: any) => {
      return item.id === value;
    });
    this.subcollocation_list = subcollocation[0]
      ? (subcollocation[0] as any).sub
      : [];
    this.subcollocation_list.forEach((item: any) => {
      this.subcollocation_list_obj[item.id] = item.name;
    });
  }

  submit() {
    this.query(1);
  }

  async query(page = 1) {
    this.page = page;
    const form = this.form;
    const send_data = {
      current: this.page,
      name: form.name,
      collocation_id: form.collocation || '',
      collocation_sub_id: form.subcollocation || '',
      price_min: form.price_min,
      price_max: form.price_max,
      online_status: form.status === 'on' ? 1 : form.status === 'off' ? 5 : '',
    };
    const res = await this.$axios.get(API.query, { params: send_data });
    if (res.data.status !== 200) {
      this.table_data = {};
      return;
    }
    const data = res.data.data || {};
    this.table_data = data;
  }

  async getCollocation() {
    const res = await this.$axios.get(API.collocation);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.collocation_list = data;
    this.collocation_list.forEach((item: any) => {
      this.collocation_list_obj[item.id] = item.name;
    });
  }

  clearForm() {
    const form = this.form;
    form.name = '';
    form.collocation = 0;
    form.subcollocation = 0;
    form.price_min = '';
    form.price_max = '';
    form.status = '0';
  }

  async created() {
    await this.getCollocation();
    await this.query(1);
  }
}
